export default [
    {
        path: '/validasi-belum-tercatat',
        redirect: '/validasi-belum-tercatat',
        name: 'validasiBelumTercatat',
        component: () => import('@/views/NestedRoute.vue'),
        children: [
            {
                path: '',
                name: 'validasiBelumTercatatIndex',
                component: () => import('@/views/validasiBelumTercatat/Index.vue'),
                meta: {
                    action: 'Lihat',
                    resource: 'validasiBelumTercatat',
                    pageTitle: 'Validasi Belum Tercatat',
                    breadcrumb: [
                        {
                            text: 'Validasi Belum Tercatat',
                            active: true,
                        },
                    ],
                },
            },
            {
                path: '/validasi-belum-tercatat/validasi/:id',
                name: 'validasiBelumTercatatValidasi',
                component: () => import('@/views/validasiBelumTercatat/Validasi.vue'),
                meta: {
                    action: 'Validasi',
                    resource: 'validasiBelumTercatat',
                    pageTitle: 'Validasi Belum Tercatat',
                    breadcrumb: [
                        {
                            text: 'Validasi Belum Tercatat',
                        },
                        {
                            text: 'Validasi',
                            active: true,
                        },
                    ],
                },
                props: true
            },
            {
                path: '/validasi-belum-tercatat/detail/:id',
                name: 'validasiBelumTercatatDetail',
                component: () => import('@/views/validasiBelumTercatat/Validasi.vue'),
                meta: {
                    action: 'Detail',
                    resource: 'validasiBelumTercatat',
                    pageTitle: 'Detail Belum Tercatat',
                    breadcrumb: [
                        {
                            text: 'Validasi Belum Tercatat',
                        },
                        {
                            text: 'Detail',
                            active: true,
                        },
                    ],
                },
                props: true
            },
        ]
    }
]